import { App } from 'vue';
import BorrowingLog from './components/common/Dialog/BorrowingLog.vue';
import BorrowConfirm from './components/modules/BorrowConfirm/BorrowConfirm.vue';
import BorrowDetail from './components/modules/BorrowDetail/BorrowDetail.vue';
import BorrowExtension from './components/modules/BorrowExtension/BorrowExtension.vue';
import BorrowReturn from './components/modules/BorrowReturn/BorrowReturn.vue';
import { API as BorrowingAPI } from './services/borrowing.service';

import '@/assets/css/main.css';

export default {
  install: (app: App): void => {
    app.component('BorrowingLog', BorrowingLog);
    app.component('BorrowConfirm', BorrowConfirm);
    app.component('BorrowReturn', BorrowReturn);
    app.component('BorrowExtension', BorrowExtension);
    app.component('BorrowDetail', BorrowDetail);
  },
};

export {
  BorrowConfirm,
  BorrowDetail,
  BorrowExtension,
  BorrowingAPI,
  BorrowingLog,
  BorrowReturn,
};
